import { gql } from "@apollo/client";

export const CREATE_OR_UPDATE_COMPANY_FIRM = gql`
  mutation CreateOrUpdateCompany($input: CompanyInput) {
    createOrUpdateCompany(input: $input) {
      success
      message
      company {
        company_type
        arcimedes_row_id
        name
        address
        city
        state
        zip
        phone
        parent_firm
        website
        deleted
        company_id
        email
      }
      error
    }
  }
`;

export const MERGE_DELETE_DUPLICATE_COMPANIES = gql`
mutation MergeAndDeleteDuplicateCompany($input: margeAndDeleteCompanyInput) {
  mergeAndDeleteDuplicateCompany(input: $input) {
    success
    message
    error
  }
}
`